import { createContext, useContext } from "react";
const ToastContext = createContext(void 0);
const useToastContext = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToastContext must be used within a ToastProvider");
  }
  return context;
};
export {
  ToastContext,
  useToastContext
};
